import {useCallback, useEffect, useState} from "react";
import globalStyle from '@/styles/Global.scss'
import {getFile} from "@/api/file";

const Photo = ({photo, onClick = () => {}}) => {
  const id = photo.id
  const mime = photo.mime
  const [data, setData] = useState('')

  const fetchImage = useCallback(async () => {
    const data = await getFile({id})
    const image = await data.text()
    setData(`data:${mime};base64,${image}`)
  }, [id, mime]);

  useEffect(() => {
    fetchImage()
  }, [fetchImage])

  return (
    <>
      {
        data !== '' &&
        <>
          <img alt={'card'} src={data} onClick={onClick} className={globalStyle.cardImage}></img>
        </>
      }
    </>
  )
}
export default Photo
